export const NEW_LISTING = 'NEW_LISTING';
export const UPDATE_LISTING = 'UPDATE_LISTING';
export const RENEW_LISTING = 'RENEW_LISTING';
export const CERTIFICATION = 'CERTIFICATION';
export const RENEW_CERTIFICATION = 'RENEW_CERTIFICATION';
export const UNPUBLISH = 'UNPUBLISH';